import { ReactNode } from 'react';

type TitleProps = { children: ReactNode; dataCy?: string };

const Title = ({ children, dataCy }: TitleProps) => {
  return (
    <>
      <div className="relative bg-[#202323] overflow-hidden hidden">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-8">
          <h1
            className="text-white text-2xl uppercase font-bold"
            data-cy={dataCy}
          >
            {children}
          </h1>
        </div>
      </div>
    </>
  );
};

export default Title;
